var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.message)?_c('div',{staticClass:"notification-container",class:_vm.customClass},[_c('div',{staticClass:"w100"},[_c('img',{attrs:{"src":_vm.theme === 'light' ? _vm.statusLightImage : _vm.statusImage,"alt":_vm.message}}),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }